import Vue from "vue";

import axios_ from "axios";
import VueAxios from "vue-axios";

import i18n from "@/lang";

export const axios = axios_.create({
  baseURL: process.env.VUE_APP_API_URL,
});

axios.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    if (error.message.indexOf("Network Error") > -1) {
      Vue.$toast.warning(i18n.t("network_error"));
    } else if (error.message.indexOf("timeout") > -1) {
      Vue.$toast.warning(i18n.t("request_timeout"));
    }

    return Promise.reject(error);
  }
);

export default {
  install(Vue) {
    Vue.axios = axios;
    Vue.use(VueAxios, axios);
  },
};
